"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigCollabLogin = void 0;
var interface_1 = require("../../../interface");
var base_1 = require("../../../base");
var request_1 = require("../../../util/request");
var base_channel_interface_1 = require("../../base-channel/base-channel.interface");
var login_interface_1 = require("./login.interface");
var websocket_channel_1 = require("../../../websocket-channel");
var util_1 = require("../../../util");
var collab_room_reporter_1 = __importDefault(require("../../../report/collab-room-reporter"));
var connect_status_manager_interface_1 = require("./connect-status-manager.interface");
var receiver_interface_1 = require("../receiver/receiver.interface");
var INVALID_TIMER = Number.MIN_VALUE;
var BigCollabLogin = /** @class */ (function () {
    function BigCollabLogin(options, dependency) {
        this.options = options;
        this.dependency = dependency;
        this.retryCount = 0;
        /**
         * 重试登陆时间间隔
         */
        this.delayConnectTime = login_interface_1.DEFAULT_DELAY_TIME;
        this.delayConnectTimer = 0;
        this.setRouteKey();
    }
    BigCollabLogin.prototype.dispose = function () {
        clearTimeout(this.delayConnectTimer);
        this.delayConnectTimer = INVALID_TIMER;
    };
    BigCollabLogin.prototype.reset = function () {
        clearTimeout(this.delayConnectTimer);
        this.delayConnectTimer = 0;
    };
    BigCollabLogin.prototype.login = function () {
        if (this.retryCount !== 0) {
            this.relogin();
        }
        else {
            // 发起bind post请求
            this.sendLoginRequest();
        }
    };
    /**
     * bind 断连，不保证回包
     * @return { boolean } 是否成功放入请求队列，不保证回包
     */
    BigCollabLogin.prototype.unlogin = function () {
        if (!this.sid || !this.token)
            return false;
        var isSended = new request_1.Request().sendBeacon(this.getUnbindPath(), __assign(__assign({}, this.createBindPostMessage("CLIENT_DISCONNECT" /* CLIENT_DISCONNECT */)), { sid: this.sid, token: this.token }));
        this.sid = undefined;
        this.token = undefined;
        return isSended;
    };
    BigCollabLogin.prototype.relogin = function (delayTime, isSubRoomFull) {
        var _this = this;
        if (this.delayConnectTimer) {
            return;
        }
        var delayConnectTime = this.getDelayConnectTime(delayTime);
        this.delayConnectTimer = setTimeout(function () {
            if (!isSubRoomFull) {
                // 重试之后还是失败通知业务连接断开
                if (_this.retryCount === interface_1.DEFAULT_RETRY_COUNTS) {
                    _this.dependency.disconnect({
                        shutDown: false,
                        reason: 'big collab login timeout.',
                    });
                }
            }
            _this.retryCount = _this.retryCount + 1;
            _this.reset();
            _this.sendLoginRequest();
        }, delayConnectTime);
    };
    BigCollabLogin.prototype.getDelayConnectTime = function (delayTime) {
        if (delayTime === undefined) {
            if (this.retryCount > interface_1.DEFAULT_RETRY_COUNTS && this.delayConnectTime === login_interface_1.DEFAULT_DELAY_TIME) {
                this.delayConnectTime = login_interface_1.MAX_DELAY_TIME;
            }
            return this.delayConnectTime;
        }
        return delayTime;
    };
    BigCollabLogin.prototype.sendLoginRequest = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var message, result;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        message = this.createBindPostMessage("BIND_POST" /* BIND_POST */);
                        this.dependency.connectStatusChange(connect_status_manager_interface_1.ConnectStatus.LOGIN);
                        util_1.ConnectionLog.info("routeKey: " + this.routeKey + ", Message: " + util_1.JsonUtil.jsonStringify(message));
                        return [4 /*yield*/, new request_1.Request().sendRequest(this.getBindPath(), base_channel_interface_1.Method.POST, message, { contentType: base_1.ContentTypeValue.JSON })];
                    case 1:
                        result = _c.sent();
                        this.handleLoginResult(result);
                        util_1.ConnectionLog.info("handleLoginResult result: " + util_1.JsonUtil.jsonStringify((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {}));
                        return [2 /*return*/];
                }
            });
        });
    };
    BigCollabLogin.prototype.createBindPostMessage = function (command) {
        var message = {
            head: util_1.createMessageHead(this.options, {
                command: command,
                baseRev: this.dependency.getVersion(),
                getHeaderGeneralPacket: this.dependency.getHeaderGeneralPacket(),
                taskId: util_1.generateMessageTaskId(),
            }),
            body: this.createPostBody(),
        };
        return message;
    };
    /**
     * 生成请求 body 数据
     * 现阶段不校验body数据 给空对象即可
     * @param message
     * @returns string
     */
    BigCollabLogin.prototype.createPostBody = function () {
        var postOptions = {};
        return util_1.JsonUtil.jsonStringify(postOptions);
    };
    /**
     * 处理返回结果
     */
    BigCollabLogin.prototype.handleLoginResult = function (result) {
        // 1、请求异常，协议异常等
        if (result.error) {
            this.relogin();
            return;
        }
        // 2、处理后台返回
        var data = result.data;
        var response = data.data;
        if (this.isLoginSuccess(response.retcode)) {
            this.handleLoginSuccess(response);
        }
        else {
            this.handleLoginFailed(response);
        }
    };
    BigCollabLogin.prototype.isLoginSuccess = function (retcode) {
        return websocket_channel_1.SERVER_SUCCESS_CODES.includes(retcode);
    };
    /**
     * 登录成功处理
     * @param response
     */
    BigCollabLogin.prototype.handleLoginSuccess = function (response) {
        // 1、重制定时器参数等
        this.reset();
        this.retryCount = 0;
        this.delayConnectTime = login_interface_1.DEFAULT_DELAY_TIME;
        this.sid = response.data.sid;
        this.token = response.data.token;
        var responseData = {
            sid: response.data.sid,
            token: response.data.token,
            routeKey: this.routeKey,
        };
        // 2、处理RoomOpen
        this.dependency.connectStatusChange(connect_status_manager_interface_1.ConnectStatus.LOGINED, responseData);
    };
    BigCollabLogin.prototype.handleLoginFailed = function (response) {
        var serverErrCode = response.retcode, errorMessage = response.msg, data = response.data;
        this.setRouteKey(data.routeKey);
        util_1.ConnectionLog.info("connect failed, serverErrCode: " + serverErrCode + ", errorMessage:" + errorMessage);
        if (this.shouldReconnect(response)) {
            collab_room_reporter_1.default.retryRequestReport({
                name: String(serverErrCode),
                message: "login error, retcode: " + serverErrCode + ", msg: " + errorMessage,
            }, this.options.module);
            this.relogin(this.getDelayConnectTime(), serverErrCode === websocket_channel_1.RoomWebsocketErrorCode.SOCKET_COLLAB_ROOM_MEMBER_FULL && !!data.routeKey);
        }
        else {
            var reason = {
                errCode: serverErrCode,
                reason: websocket_channel_1.RoomUtil.getWebsocketChannelErrorMessage(serverErrCode, 'connect failed.'),
                shutDown: !websocket_channel_1.NEED_RETRY_ERRCODES.includes(serverErrCode),
            };
            this.dependency.connectStatusChange(connect_status_manager_interface_1.ConnectStatus.LOGIN_FAIL, undefined, reason);
        }
    };
    BigCollabLogin.prototype.setRouteKey = function (routeKey) {
        this.routeKey = routeKey !== null && routeKey !== void 0 ? routeKey : this.options.serverVars.globalPadId;
    };
    BigCollabLogin.prototype.shouldReconnect = function (response) {
        var serverErrCode = response.retcode, data = response.data;
        // 特殊逻辑，满员如果有routeKey则继续带着routeKey加入子房间，否则表示后台所有子房间满员，不再重连。
        if (serverErrCode === websocket_channel_1.RoomWebsocketErrorCode.SOCKET_COLLAB_ROOM_MEMBER_FULL) {
            // 所有子房间已满
            if (!data.routeKey) {
                return false;
            }
            // 继续尝试加入子房间
            return true;
        }
        return websocket_channel_1.NEED_RETRY_ERRCODES.includes(serverErrCode) && this.retryCount < 3;
    };
    BigCollabLogin.prototype.getBindPath = function () {
        if (!this.routeKey) {
            this.setRouteKey();
        }
        return receiver_interface_1.PATH + "?routeKey=" + this.routeKey;
    };
    BigCollabLogin.prototype.getUnbindPath = function () {
        if (!this.routeKey) {
            this.setRouteKey();
        }
        return "/websocket/save?routeKey=" + this.routeKey;
    };
    return BigCollabLogin;
}());
exports.BigCollabLogin = BigCollabLogin;
